import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
import Course from "@/models/lms/Course"
import Module from "@/models/lms/Module"
import Lesson from "@/models/lms/Lesson"
import GenexHelperMixins from "@/mixins/GenexHelperMixins";

export default class UserLessonNote extends GenexLMSModel {
    static entity = 'user-lesson-notes'

    static fields() {
        return {
            type: this.attr(''),
            id: this.attr(null),
            user_id: this.attr(null),
            course_id: this.attr(null),
            course: this.belongsTo(Course, 'course_id'),
            module_id: this.attr(null),
            module: this.belongsTo(Module, 'module_id'),
            lesson_id: this.attr(null),
            lesson: this.belongsTo(Lesson, 'lesson_id'),
            section: this.attr(''),
            content: this.attr(''),
            created_at: this.attr(''),
        }
    }

    static FetchById(id, relationships = []) {
        return this.api().get(`/userlessonnotes/${id}`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
            params: {
                with: relationships,
            },
            dataTransformer: ({data: {data}}) => {
                return GenexHelperMixins.methods.NormalizeRecursive(data);
            },
        });
    }

    static FetchAll({page = 1, limit = 15}, query = {}, relationships = []) {
        return this.api().get(`/userlessonnotes`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                params: {page: page, limit: limit, with: relationships, ...query},
                dataTransformer: ({data: {data}}) => {
                    return GenexHelperMixins.methods.NormalizeRecursive(data);
                },
            }
        )
    }


    static Update(entity, save = true) {
        return this.api().put(`/userlessonnotes/${entity.id}`, entity, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
            dataTransformer: ({data: {data}}) => {
                return {...data, ...data.attributes};
            },
            save: save,
        });
    }
}